<!--
 * @Descripttion:
 * @version:
 * @Author: yanghui
 * @Date: 2022-07-22 10:06:45
 * @LastEditors: yanghui
 * @LastEditTime: 2022-08-17 10:15:54
-->
<template>
    <div class="newContent">
        <div class="theTitle" v-if="type==1">添加已执行订单</div>
        <div class="theTitle" v-if="type==2">编辑已执行订单</div>
        <!-- 查询客户邮箱 -->
        <div style="margin-bottom:20px;">
            <el-form ref="form" :model="form" label-width="100px" @submit.native.prevent>
                <el-form-item label="客户邮箱：">
                    <el-input v-model="form.userEmail" style="width: 300px;margin-right: 20px;"
                        @keyup.enter.native="isUserEmailFn" v-if="type==1"></el-input>
                    <el-button type="primary" width="100px" v-if="type==1" @click="isUserEmailFn">查询</el-button>
                    <div v-if="type==2">{{theForm.mbUser.useremail}}</div>
                </el-form-item>
            </el-form>
            <div v-if="remind==true" style="color:red;padding-left:17px;">未检索到该客户信息！请先在【用户管理】模块中新增客户信息，再进行【执行订单添加】</div>
        </div>
        <div style="margin: 0px 17px;" v-if="showContent==true">
            <el-form ref="theForm" :model="theForm" label-width="200px">
                <!-- 电子订单 -->
                <div class="blueTitle">电子订单</div>
                <div class="formFlex">
                    <div>
                        <el-form-item label="序号">
                            <el-input v-model="theForm.guid" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="报送时间">
                            <el-input v-model="theForm.appTime" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="订单编号">
                            <el-input v-model="theForm.orderNo"></el-input>
                        </el-form-item>
                        <el-form-item label="电商平台代码">
                            <el-input v-model="theForm.ebpCode"></el-input>
                        </el-form-item>
                        <el-form-item label="电商企业代码">
                            <el-input v-model="theForm.ebcCode"></el-input>
                        </el-form-item>
                        <el-form-item label="商品金额">
                            <el-input v-model="theForm.goodsValue" style="width:360px;margin-right: 10px;"></el-input>
                            <span style="color: #606266;"></span>
                        </el-form-item>
                        <el-form-item label="币制">
                            <el-select v-model="theForm.currency" placeholder="请选择" style="width:380px">
                                <el-option v-for="(item,index) in moneyType" :key="index" :label="item.name"
                                    :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="传输ID">
                            <el-input v-model="theForm.dxpId"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="报送类型">
                            <el-select v-model="theForm.appType" placeholder="请选择" style="width:380px">
                                <el-option label="新增" :value="1"></el-option>
                                <el-option label="变更" :value="2"></el-option>
                                <el-option label="删除" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="报送状态">
                            <el-select v-model="theForm.appStatus" placeholder="请选择" style="width:380px">
                                <el-option label="暂存" :value="1"></el-option>
                                <el-option label="申报" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="订单类型">
                            <el-select v-model="theForm.orderType" placeholder="请选择" style="width:380px">
                                <el-option label="进口商品订单" value="I"></el-option>
                                <el-option label="出口商品订单" value="B"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="电商平台名称">
                            <el-input v-model="theForm.ebpName"></el-input>
                        </el-form-item>
                        <el-form-item label="电商企业名称">
                            <el-input v-model="theForm.ebcName"></el-input>
                        </el-form-item>
                        <el-form-item label="运杂费">
                            <el-input v-model="theForm.freight" style="width:360px;margin-right: 10px;"></el-input><span
                                style="color: #606266;"></span>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="theForm.note" type="textarea" :autosize="{ minRows: 4}">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <!-- 导入弹窗 -->
                <el-dialog title="导入文件" :visible.sync="showImport" width="30%">
                    <div class="flexCenter">
                        <el-upload class="upload-demo" drag :show-file-list="false" :http-request="uploadFile"
                            :before-upload="beforeAvatarUpload" action="file">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                        </el-upload>
                        <div style="width:360px;">
                            <div>{{filename}} <i v-if="filename" class="el-icon-delete delFile" @click="delFileFn"></i>
                            </div>
                            <el-progress :percentage="progressTotal>100?100:progressTotal" status="success"
                                v-if="filename"></el-progress>
                        </div>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="cancelImport">取 消</el-button>
                        <el-button type="primary" @click="uploadConfirm">确 定</el-button>
                    </span>
                </el-dialog>

                <!-- 商品列表 -->
                <div class="blueTitle" style="margin-bottom:30px">商品列表</div>
                <div class="flexButton">
                    <el-link type="primary" href="https://hfmeshop.oss-us-west-1.aliyuncs.com/templateNew.xls" target="_blank" style="margin-right: 30px">下载导入模板</el-link>
                    <el-button type="primary" width="100px" @click="openImport">导入</el-button>
                    <el-button type="primary" width="100px" @click="addItem">添加</el-button>
                </div>
                <el-table :data="theForm.otherorderCommodityDTOList"
                    :header-cell-style="{ background: '#F4F4F5', color: '#606266' }">
                    <el-table-column label="序号" align="center" prop="gnum" show-overflow-tooltip></el-table-column>
                    <el-table-column label="企业商品货号" align="center" prop="itemNo" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.itemNo"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.itemNo }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="企业商品名称" align="center" prop="itemName" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.itemName"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.itemName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="企业商品描述" align="center" prop="itemDescribe" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.itemDescribe"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.itemDescribe }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="条形码" align="center" prop="barCode" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.barCode"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.barCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="计量单位" align="center" prop="unit" show-overflow-tooltip>
                        <template scope="scope">
                            <el-select v-if="scope.row.isOk" v-model="scope.row.unit" placeholder="请选择">
                                <el-option v-for="(item,index) in unitData" :key="index" :label="item.name"
                                    :value="item.code"></el-option>
                            </el-select>
                            <span v-if="!scope.row.isOk">{{ scope.row.unitname }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="币制" align="center" prop="currency" show-overflow-tooltip>
                        <template scope="scope">
                            <!--                            <el-input v-if="scope.row.isOk" v-model="scope.row.currency" v-for="(item,index) in moneyType" :key="index" :label="item.name"-->
                            <!--                                      :value="item.id"></el-input>-->
                            <template v-for="(item) in moneyType">
                                <span v-if="scope.row.currency==item.code">{{item.name}}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" align="center" prop="qty" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.qty"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.qty }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单价" align="center" prop="price" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.price"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.price }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="总价" align="center" prop="totalPrice" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.totalPrice"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.totalPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center" prop="note" show-overflow-tooltip>
                        <template scope="scope">
                            <el-input v-if="scope.row.isOk" v-model="scope.row.note"></el-input>
                            <span v-if="!scope.row.isOk">{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit-outline" v-if="!scope.row.isOk"
                                @click="handleEdit(scope.$index, scope.row)" :style="{color:'green',fontSize:'18px'}"
                                circle>
                            </el-button>
                            <el-button icon="el-icon-folder-checked" v-if="scope.row.isOk"
                                @click="handleSDave(scope.$index, scope.row)" :style="{color:'blue',fontSize:'18px'}"
                                circle></el-button>
                            <el-button icon="el-icon-delete" @click="deleteFn(scope.$index)"
                                :style="{color:'red',fontSize:'18px'}" circle></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div class="buttonBox">
                <div>
                    <el-button type="primary" @click="submitFn">提交</el-button>
                </div>
                <div>
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="saveFn">保存</el-button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        isUserEmail,
        getCoinDict,
        save,
        submit,
        getInfoApi,
        getUnitApi
    } from "../../api/order/otherOrderForm.js";
    import {
        getAdminId
    } from "@/utils/auth";
    import {
        uploadreportApi
    } from "@/utils/axios";

    export default {
        data() {
            return {
                type: 0, //1添加 2编辑
                form: {
                    userEmail: ''
                },
                remind: false, //是否显示提示
                showContent: false, //是否显示电子订单商品列表
                theForm: {
                    authadminid: '',
                    mbuserid: '',
                    otherorderCommodityDTOList: [],
                    mbUser: {
                        useremail: ''
                    },
                    appType: 1, // 报送类型
                    appStatus: 2, // 报送状态
                    orderType: 'B', // 订单类型 出口
                    ebpCode: '1101961411',
                    ebpName: '霍夫曼(北京)工程技术有限公司',
                    ebcCode: '1101961411',
                    ebcName: '霍夫曼(北京)工程技术有限公司',
                    dxpId: 'DXPENT0000472916'
                },
                moneyType: [], //币制
                otherorderId: '', //查看过来的id
                showImport: false, //导入弹窗
                file: "",
                filename: "",
                progressTotal: 0,
                unitData:[],//计量单位
            };
        },
        methods: {
            // 计量单位
            getUnitApiFn() {
                getUnitApi({})
                    .then(res => {
                        if (res.data) {
                            this.unitData = res.data;
                        }
                    })
                    .catch(() => {

                    });
            },
            // 客户邮箱查询数据
            isUserEmailFn() {
                if (!this.form.userEmail) {
                    this.$message.error('请输入邮箱');
                    return
                }
                let data = this.form;
                isUserEmail(data)
                    .then(res => {
                        if (res.data) {
                            this.remind = false;
                            this.showContent = true;
                            this.theForm.mbuserid = res.data.userid;
                        }
                        if (res.data == null) {
                            this.remind = true;
                            this.showContent = false;
                        }
                    })
                    .catch(() => {

                    });
            },
            // 查币制
            getCoinDictFn() {
                getCoinDict({})
                    .then(res => {
                        if (res.data) {
                            this.moneyType = res.data;
                            // this.moneyType.forEach(item=>{
                            //     // item.code = item.code
                            // })
                        }
                    })
                    .catch(() => {

                    });
            },
            // 点击查看获取详情
            getInfoFn() {
                let data = {
                    otherorderId: this.otherorderId
                }
                getInfoApi(data)
                    .then(res => {
                        if (res.data) {
                            this.theForm = res.data;
                            if (this.theForm.currency) {
                                // this.theForm.currency = Number(this.theForm.currency);
                                this.theForm.currency = this.theForm.currency;
                            }
                        }
                    })
                    .catch(() => {

                    });
            },
            // 保存按钮
            saveFn() {
                if (this.theForm.otherorderCommodityDTOList.length > 50) {
                    this.$message.error('商品列表最多50条，当前条数：' + this.theForm.otherorderCommodityDTOList.length +
                        '条，请删除多余条数后再操作')
                    return
                }
                let data = this.theForm;
                save(data)
                    .then(res => {
                        console.log('保存', res)
                        if (res.message == 'success') {
                            this.$message.success('保存成功')
                            this.$router.go(-1);
                        } else {
                            this.$message.error('保存失败')
                        }

                    })
                    .catch(() => {

                    });
            },
            // 提交按钮
            submitFn() {
                if (!this.theForm.appType) {
                    this.$message.error('请选择报送类型')
                    return
                }
                if (!this.theForm.appStatus) {
                    this.$message.error('请选择报送状态')
                    return
                }
                if (!this.theForm.orderNo) {
                    this.$message.error('请填写订单编号')
                    return
                }
                if (!this.theForm.orderType) {
                    this.$message.error('请选择订单类型')
                    return
                }
                if (!this.theForm.ebpCode) {
                    this.$message.error('请填写电商平台代码')
                    return
                }
                if (!this.theForm.ebpName) {
                    this.$message.error('请填写电商平台名称')
                    return
                }
                if (!this.theForm.ebcCode) {
                    this.$message.error('请填写电商企业代码')
                    return
                }
                if (!this.theForm.ebcName) {
                    this.$message.error('请填写电商企业名称')
                    return
                }
                if (!this.theForm.goodsValue) {
                    this.$message.error('请填写商品金额')
                    return
                }
                // if (!this.theForm.freight) {
                //     this.$message.error('请填写运杂费')
                //     return
                // }
                if (!this.theForm.currency) {
                    this.$message.error('请选择币制')
                    return
                }
                if (!this.theForm.dxpId) {
                    this.$message.error('请填写传输ID')
                    return
                }
                // if (!this.theForm.note) {
                //     this.$message.error('请填写备注')
                //     return
                // }
                if (this.theForm.otherorderCommodityDTOList.length < 1) {
                    this.$message.error('商品列表最少一条')
                    return
                }
                if (this.theForm.otherorderCommodityDTOList.length > 50) {
                    this.$message.error('商品列表最多50条，当前条数：' + this.theForm.otherorderCommodityDTOList.length +
                        '条，请删除多余条数后再操作')
                    return
                }
                let data = this.theForm;
                submit(data)
                    .then(res => {
                        console.log('提交', res)
                        if (res.message == 'success') {
                            this.$message.success('提交成功')
                            this.$router.go(-1);
                        } else {
                            this.$message.error(res.message)
                        }

                    })
                    .catch(() => {

                    });
            },
            // 取消按钮
            cancel() {
                this.$router.go(-1);
            },
            // 商品列表编辑
            handleEdit(index, row) {
                row.isOk = !row.isOk;
                console.log(index, row);
            },
            handleSDave(index, row) {
                if (!row.itemNo) {
                    this.$message.error('必填项未填写')
                    return
                }
                if (!row.itemName) {
                    this.$message.error('必填项未填写')
                    return
                }
                if (!row.itemDescribe) {
                    this.$message.error('必填项未填写')
                    return
                }
                // if (!row.barCode) {
                //     this.$message.error('必填项未填写')
                //     return
                // }
                if (!row.unit) {
                    this.$message.error('必填项未填写')
                    return
                }
                // if (!row.currency) {
                //     this.$message.error('必填项未填写')
                //     return
                // }
                if (!row.qty) {
                    this.$message.error('必填项未填写')
                    return
                }
                if (!row.price) {
                    this.$message.error('必填项未填写')
                    return
                }
                if (!row.totalPrice) {
                    this.$message.error('必填项未填写')
                    return
                }
                // if (!row.note) {
                //     this.$message.error('必填项未填写')
                //     return
                // }
                this.unitData.find(item => {
                    if (item.code == row.unit) row.unitname = item.name
                })
                row.isOk = !row.isOk;
            },
            // 添加按钮
            addItem() {
                if (this.theForm.otherorderCommodityDTOList.length >= 50) {
                    this.$message.error('最多添加50条商品')
                    return
                }
                this.theForm.otherorderCommodityDTOList.push({
                    isOk: true,
                    // itemNo:'1101961411',
                    // itemName:'霍夫曼(北京)⼯程技术有限公司',
                })

            },
            // 删除按钮
            deleteFn(index) {
                this.$confirm('是否删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.theForm.otherorderCommodityDTOList.splice(index, 1)
                }).catch(() => {

                });
                console.log(this.theForm.otherorderCommodityDTOList)
            },
            // 打开导入弹窗
            openImport() {
                if (this.theForm.otherorderCommodityDTOList.length >= 50) {
                    this.$message.error('商品列表最多50条，当前条数：' + this.theForm.otherorderCommodityDTOList.length +
                        '条，请删除多余条数后再操作')
                    return
                }
                this.file = "";
                this.filename = "";
                this.progressTotal = 0;
                this.showImport = true;
            },
            delFileFn() {
                this.file = "";
                this.filename = "";
                this.progressTotal = 0;
            },
            uploadFile(res) {
                this.file = res.file;
                this.filename = res.file.name
                setTimeout(() => {
                    for (var i = 0; i < 100; i++) {
                        this.progressTotal += i
                        console.log('多少', this.progressTotal)
                    }
                }, 1000)
            },
            cancelImport() {
                this.showImport = false;
            },
            uploadConfirm() {
                if (!this.file) {
                    this.$message.error('请选择文件');
                    return
                }
                let data = new FormData();
                data.append("file", this.file);
                uploadreportApi(data).then(res => {
                    console.log('上传的res', res)
                    if (res.code == 0) {
                        if (res.data) {
                            this.$message.success('导入成功')
                            this.showImport = false;
                            res.data.forEach(item => {
                                item.isOk = false;
                                this.unitData.find(item1 => {
                                    if (item1.code == item.unit) item.unitname = item1.name
                                })
                                this.theForm.otherorderCommodityDTOList.push(item)
                            });

                        }
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            beforeAvatarUpload(file) {
                let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                const extension = testmsg === 'xls'
                const extension2 = testmsg === 'xlsx'
                // const isLt2M = file.size / 1024 / 1024 < 2
                if (!extension && !extension2) {
                    this.$message.error('只能上传 xls 或者 xlsx 文件')
                    return false;
                }
            }
        },
        created() {
            this.getCoinDictFn();
            this.getUnitApiFn();
            this.type = this.$route.query.type;
            if (this.type == 2) {
                this.otherorderId = this.$route.query.otherorderId;
                this.getInfoFn();
                this.showContent = true;
            }
            this.theForm.authadminid = getAdminId();
        }
    };

</script>

<style scoped>
    .newContent {
        color: #000000;
        font-family: PingFangSC-Semibold, PingFang SC;
        padding: 10px 30px;
    }

    .theTitle {
        font-size: 20px;
        margin-bottom: 40px;
    }

    .blueTitle {
        font-size: 18px;
        color: #409eff;
        margin-top: 30px;
        padding-bottom: 15px;
        border-bottom: 1px solid #409eff;
        font-weight: 600;
    }

    .formFlex {
        display: flex;
        padding: 40px 20px 20px 80px;

    }

    .formFlex>div {
        width: 580px;
    }

    .flexButton {
        margin-bottom: 30px;
        display: flex;
        justify-content: flex-end;
    }

    .buttonBox {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
    }

    .flexCenter {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .delFile {
        margin-left: 10px;
        cursor: pointer;
    }

</style>
